import axios from 'axios';

const base = `${process.env.REACT_APP_BACKEND_URL}/api`;
export const supportRequest = async (path, { key, ...options } = {}) => {
  const response = await axios({ url: `${base}${path}`, ...options,
    headers: { ...(options.headers || {}), ...(key ? { 'X-Admin-Key': key } : {}) } });
  return response.data;
};
export const supportError = error => typeof error.response?.data?.detail === 'string' ? error.response.data.detail : 'Unable to complete the request. Please try again.';
export const supportDate = value => value ? new Date(value).toLocaleString() : 'Date unavailable';
export const categories = { issue: 'Report an issue', question: 'Ask a question', concern: 'Other concern' };